import { render, staticRenderFns } from "./brief.vue?vue&type=template&id=7bdfef6f&"
import script from "./brief.vue?vue&type=script&lang=js&"
export * from "./brief.vue?vue&type=script&lang=js&"
import style0 from "./brief.vue?vue&type=style&index=0&id=7bdfef6f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports